export default {
    "map_landmarksettings_landmarks": "Landmarks",
    "map_landmarksettings_landmarks_groups": "Landmark Groups",
    "map_landmarksettings_landmarks_tags": "Tags:",
    "map_landmarksettings_landmarks_note": "Notes",
    "map_landmarksettings_landmarks_none": "None",
};